import { useEffect } from "react";

export const SITE_URL = "https://complaintadvisor.com";

function upsertMeta(selector, create, content) {
  let el = document.head.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  if (content !== undefined) el.setAttribute("content", content);
  return el;
}

// Reusable SEO head manager: title, description, canonical, Open Graph, Twitter, robots, JSON-LD.
export default function Seo({ title, description, path, image, type = "website", noindex = false, jsonld }) {
  useEffect(() => {
    if (title) document.title = title;
    const canonical = SITE_URL + (path || window.location.pathname);
    const img = image || `${SITE_URL}/og-default.png`;

    if (description) upsertMeta('meta[name="description"]', () => Object.assign(document.createElement("meta"), { name: "description" }), description);
    upsertMeta('meta[property="og:title"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:title"); return m; }, title || "");
    upsertMeta('meta[property="og:description"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:description"); return m; }, description || "");
    upsertMeta('meta[property="og:type"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:type"); return m; }, type);
    upsertMeta('meta[property="og:url"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:url"); return m; }, canonical);
    upsertMeta('meta[property="og:image"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:image"); return m; }, img);
    upsertMeta('meta[name="twitter:card"]', () => Object.assign(document.createElement("meta"), { name: "twitter:card" }), "summary_large_image");
    upsertMeta('meta[name="twitter:title"]', () => Object.assign(document.createElement("meta"), { name: "twitter:title" }), title || "");
    upsertMeta('meta[name="twitter:description"]', () => Object.assign(document.createElement("meta"), { name: "twitter:description" }), description || "");
    upsertMeta('meta[name="twitter:image"]', () => Object.assign(document.createElement("meta"), { name: "twitter:image" }), img);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = canonical;

    upsertMeta('meta[name="robots"]', () => Object.assign(document.createElement("meta"), { name: "robots" }),
      noindex ? "noindex, nofollow, noarchive" : "index, follow");

    let s = document.getElementById("seo-jsonld");
    if (jsonld) {
      if (!s) { s = document.createElement("script"); s.id = "seo-jsonld"; s.type = "application/ld+json"; document.head.appendChild(s); }
      s.textContent = JSON.stringify(jsonld);
    } else if (s) { s.remove(); }

    return () => {
      document.title = "ComplaintAdvisor";
      const j = document.getElementById("seo-jsonld");
      if (j) j.remove();
      const r = document.head.querySelector('meta[name="robots"]');
      if (r) r.setAttribute("content", "index, follow");
    };
  }, [title, description, path, image, type, noindex, jsonld]);

  return null;
}
